import { render, staticRenderFns } from "./m-article-2-column-stats.vue?vue&type=template&id=1f0214bc&scoped=true"
import script from "./m-article-2-column-stats.vue?vue&type=script&lang=js"
export * from "./m-article-2-column-stats.vue?vue&type=script&lang=js"
import style0 from "./m-article-2-column-stats.vue?vue&type=style&index=0&id=1f0214bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0214bc",
  null
  
)

export default component.exports